module.exports = __webpack_public_path__ + "static/img/mother.8c664f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/source/mother.png
// module id = vrAr
// module chunks = 1